import React, { useState } from "react";
import { getUrlQueryParam } from "~/assets/js/Helpers/util";
import i18n from "~/assets/js/Helpers/i18n";
import { setPassword } from "~/assets/js/Api/userApi";
import { ResetPasswordForm } from "~/assets/js/components/Forms/modules";
import CustomerNotification from "../CustomerArea/components/CustomerNotification";

const Recover = () => {
    const [isLoading, setLoading] = useState(false);
    const [notification, setNotification] = useState({
        show: false,
        variant: "success",
    });

    const handleSubmit = async ({ password }) => {
        setLoading(true);
        const response = await setPassword(token, password);
        setLoading(false);
        if (!response.ok) {
            setNotification({
                show: true,
                variant: "danger",
            });
            return;
        }
        setNotification({
            show: true,
            variant: "success",
        });
    };

    const token = getUrlQueryParam("token");

    if (!token) {
        return (
            <div>
                <p>{i18n.t("resetPassword.invalidLink")}</p>
            </div>
        );
    }

    return (
        <div>
            <CustomerNotification
                show={notification.show}
                path={"setPassword"}
                variant={notification.variant}
            />
            <ResetPasswordForm isLoading={isLoading} onSubmit={handleSubmit} />
        </div>
    );
};

export default Recover;
